@if (displayModeChangeVisible) {
<div class="flex justify-content-end mb-2">
  <p-selectButton
    [options]="modeOptions"
    [(ngModel)]="displayMode"
    optionLabel="icon"
    optionValue="value"
  >
    <ng-template let-item pTemplate>
      <i [class]="item.icon"></i>
    </ng-template>
  </p-selectButton>
</div>
} @if (render) {
<div class="flex gap-3">
  <!-- @if (isStepperVisible()) {
  <div class="h-30rem overflow-y-auto w-5">
    <p-panelMenu [model]="groupLists">
      <ng-template let-item pTemplate="item">
        <div
          class="flex gap-2 align-items-center text-sm cursor-pointer p-2"
          [ngClass]="{
            'font-semibold bg-gray-100 text-blue-500':
              item.id === selectedFormPanel?.name,
            'text-green-600': isFormPanelValid(item.id)
          }"
          (click)="onGroupItemClick(item)"
        >
          <i
            class="pi {{
              isFormPanelValid(item.id)
                ? 'pi-check bg-green-600 text-white text-xs p-1'
                : 'pi-circle text-xl'
            }} border-circle "
          ></i>
          {{ item.label }}
        </div>
      </ng-template>
    </p-panelMenu>
  </div>
  } -->

  <form class="w-full" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex flex-column gap-3 {{ getStyleClass() }}">
      <ng-container *ngFor="let c of formPanelConfigs">
        <eo-form-panel
          #eoFormPanels
          *ngIf="c.visible"
          [formGroup]="c.getFormGroupFromForm(form)"
          [customFormControls]="customFormControls"
          [config]="c"
        />
      </ng-container>
      @if (isSubmitButtonVisible()) {
      <div [class]="getSubmitButtonDivStyleClass()">
        <p-button
          type="submit"
          [label]="getSubmitButtonLabel()"
          [styleClass]="getSubmitButtonStyleClass()"
          [disabled]="isSubmitButtonDisabled()"
          [loading]="isSubmitButtonLoading()"
          [icon]="getIcon()"
        />
      </div>
      }
    </div>
    <button type="submit" style="display: none"></button>
  </form>
</div>
}
